module.exports = __webpack_public_path__ + "static/img/xjs.a3c7f0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xjs.png
// module id = crIW
// module chunks = 0